// extracted by css-extract-rspack-plugin
export default {"loading":"loading-dmAxXG","spinner":"spinner-oNsawx","spin":"spin-ehJdoi"};